import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { getTranslation } from './translations';
import LanguageSelector from './LanguageSelector';

function RegistrationSuccess() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleGoToLogin = () => {
    // Redirect to the root URL instead of relative path
    window.location.href = '/';
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f0f8ff',
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: window.innerWidth <= 600 ? '20px 20px' : '40px 0',
      fontFamily: 'Nunito, Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Language Selector */}
      <div style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 1000 }}>
        <LanguageSelector />
      </div>
      
      {/* Main Title */}
      <h1 style={{
        fontSize: window.innerWidth <= 600 ? '2.5rem' : '3.5rem',
        fontWeight: 'bold',
        color: '#7c3aed',
        margin: '0 0 16px 0',
        textAlign: 'center',
        padding: window.innerWidth <= 600 ? '0 20px' : '0'
      }}>
        {getTranslation('shootMe', language)}
      </h1>
      
      {/* Subtitle */}
      <p style={{
        fontSize: window.innerWidth <= 600 ? '1rem' : '1.2rem',
        color: '#6b7280',
        margin: '0 0 48px 0',
        textAlign: 'center',
        maxWidth: window.innerWidth <= 600 ? '90%' : '600px',
        lineHeight: '1.6',
        padding: window.innerWidth <= 600 ? '0 20px' : '0'
      }}>
        {getTranslation('rejestracja-zakonczona-pomyslnie', language)}
      </p>

      <div style={{
        background: 'white',
        borderRadius: window.innerWidth <= 600 ? 16 : 20,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
        maxWidth: window.innerWidth <= 600 ? '95%' : 500,
        width: window.innerWidth <= 600 ? '95%' : 500,
        padding: window.innerWidth <= 600 ? 24 : 32,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '60px',
            height: '60px',
            background: '#10b981',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            fontSize: '30px',
            color: 'white'
          }}>
            ✓
          </div>
          <h2 style={{ 
            color: '#10b981', 
            marginBottom: 16, 
            fontFamily: 'Nunito, Arial, sans-serif', 
            fontWeight: 700 
          }}>
            {getTranslation('rejestracja-zakonczona', language)}
          </h2>
          <p style={{ color: '#6b7280', marginBottom: 24, lineHeight: '1.6' }}>
            {getTranslation('dziekujemy-za-rejestracje', language)}
          </p>
          <p style={{ color: '#6b7280', marginBottom: 24, lineHeight: '1.6' }}>
            {getTranslation('aby-aktywowac-konto', language)}
          </p>
          <p style={{ color: '#6b7280', marginBottom: 32, lineHeight: '1.6', fontSize: '0.9rem' }}>
            {getTranslation('po-weryfikacji-emaila', language)}
          </p>
          <button 
            onClick={handleGoToLogin}
            style={{
              padding: '12px 24px',
              borderRadius: 8,
              border: 'none',
              background: '#7c3aed',
              color: 'white',
              fontWeight: 700,
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          >
            {getTranslation('przejdz-do-strony-glownej', language)}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RegistrationSuccess;
